import { useEffect, Suspense, useMemo } from "react";
import { useAutoSignin } from "react-oidc-context";

import { useAppDispatch } from "redux/store/hooks";
import Layout from "hoc/Layout/Layout";
import Router from "./routes/Router";
import Loader from "components/Loader/CustomLoader";
import ErrorHandler from "components/ErrorHandler/ErrorHandler";
import useUserRoles from "shared/hooks/useUserRoles";
import * as actions from "redux/store/actions";

const App = () => {
  const { isLoading, isAuthenticated, error } = useAutoSignin();

  // Placing user roles in redux so class components can access them - eventually remove class components and use hooks
  const { userRoles } = useUserRoles();
  const dispatch = useAppDispatch();
  const userRolesString = useMemo(() => userRoles.join(","), [userRoles]);
  useEffect(() => {
    dispatch(actions.saveUserRoles(userRolesString));
  }, [dispatch, userRolesString]);
  // Placing user roles in redux so class components can access them - eventually remove class components and use hooks

  if (isLoading) {
    return <div>Signing you in/out...</div>;
  }

  if (error) {
    console.error("Authentication error:", error);
    return (
      <div>
        An authentication error occurred: {error.message || String(error)}
      </div>
    );
  }

  if (!isAuthenticated) {
    return <div>Unable to log in</div>;
  }

  return (
    <ErrorHandler>
      <Layout>
        <Suspense
          fallback={
            <div className="app-container-loader">
              <Loader />
            </div>
          }
        >
          <Router />
        </Suspense>
      </Layout>
    </ErrorHandler>
  );
};

export default App;
